export const kebabCase = (text) => text.toLowerCase().split(' ').join('-');
